import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import ScrollToTop from './Component /Common/ScrollToTop';
import Home from './Component /Pages/Home';
import AboutUs from './Component /Pages/AboutUs';
import Sermons from './Component /Sermon/Sermons';
import SermonDetails from './Component /Sermon/SermonDetails';
import Ministries from './Component /Ministries/Ministies';
import WorshipCreativeArts from './Component /Ministries/WorshipCreativeArts';
import LifeStage from './Component /Ministries/LifeStage';
import OutreachService from './Component /Ministries/OutreachService';
import SupportGrowth from './Component /Ministries/SupportGrowth';
import JoinUs from './Component /Ministries/JoinUs';
import Event from './Component /Pages/Event';
import ContactUs from './Component /Pages/ContacUs';
import Giving from './Component /Pages/Giving';
import AdminLogin from './Component /Admin/AdminLogin';
import AdminSignup from './Component /Admin/AdminSignup';
import AdminDashboard from './Component /Admin/AdminDashboard';
import SermonList from './Component /Admin/SermonList';
import AddEditSermon from './Component /Admin/AddEditSermon';
import EventList from './Component /Admin/EventList';
import AddEditEvent from './Component /Admin/AddEditEvent';
import Messages from './Component /Admin/Messages';
import Subscribers from './Component /Admin/Subscribers';
import Settings from './Component /Admin/Settings';
import MinistryRequests from './Component /Admin/MinistryRequests';
import MinistryMembers from './Component /Admin/MinistryMembers';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/sermon" element={<Sermons />} />
        <Route path="/sermon/:id" element={<SermonDetails />} />
        <Route path="/ministries" element={<Ministries />} />
        <Route path="/ministries/worship-creative-arts" element={<WorshipCreativeArts />} />
        <Route path="/ministries/life-stage" element={<LifeStage />} />
        <Route path="/ministries/outreach-service" element={<OutreachService />} />
        <Route path="/ministries/support-growth" element={<SupportGrowth />} />
        <Route path="/ministries/join" element={<JoinUs />} />
        <Route path="/events" element={<Event />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/giving" element={<Giving />} />
        
        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/signup" element={<AdminSignup />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/sermons" element={<SermonList />} />
        <Route path="/admin/sermons/add" element={<AddEditSermon />} />
        <Route path="/admin/sermons/edit/:id" element={<AddEditSermon />} />
        <Route path="/admin/events" element={<EventList />} />
        <Route path="/admin/events/add" element={<AddEditEvent />} />
        <Route path="/admin/events/edit/:id" element={<AddEditEvent />} />
        <Route path="/admin/messages" element={<Messages />} />
        <Route path="/admin/subscribers" element={<Subscribers />} />
        <Route path="/admin/ministry-requests" element={<MinistryRequests />} />
        <Route path="/admin/ministry-members" element={<MinistryMembers />} />
        <Route path="/admin/settings" element={<Settings />} />
        
        {/* Add more routes as needed */}
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
